module.exports = __webpack_public_path__ + "au.svg?f6b7907ce4405df5f8c7d1abbbadafd5";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/au.svg
// module id = 980
// module chunks = 0